import { queryOptions } from '@tanstack/react-query'

import { getStickyBanner } from './action'

export const stickyBannerQueryOptions = queryOptions({
  queryKey: ['sticky-banner'],
  queryFn: () => getStickyBanner(),
  retry: 2,
  staleTime: 60_000,
})
